var map = {
	"./project-1.jpg": "4a3d",
	"./project-10.jpg": "0f68",
	"./project-2.jpg": "e279",
	"./project-3.jpg": "2aec",
	"./project-4.jpg": "93d2",
	"./project-5.jpg": "7cfb",
	"./project-6.jpg": "df55",
	"./project-7.jpg": "d5f2",
	"./project-8.jpg": "f6ee",
	"./project-9.jpg": "bcbe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ef29";